import { render, staticRenderFns } from "./navigationPartner.vue?vue&type=template&id=266552bb&scoped=true"
import script from "./navigationPartner.vue?vue&type=script&lang=js"
export * from "./navigationPartner.vue?vue&type=script&lang=js"
import style0 from "./navigationPartner.vue?vue&type=style&index=0&id=266552bb&prod&lang=less"
import style1 from "./navigationPartner.vue?vue&type=style&index=1&id=266552bb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266552bb",
  null
  
)

export default component.exports